export enum PosIdEnum {
  // 牌桌上三档花色区分
  peacock = 1,
  elephant,
  tiger,
}

export enum SuitTypeEnum {
  // 1:方片;2:梅花;3:红桃;4:黑桃;
  square = 1,
  plumBossom = 2,
  heart = 3,
  spade = 4,
}
export interface order_log_list_type {
  // 中奖记录
  round_no: string
  ct: string
  bet_coins: number
  win_coins: number
}

export enum StatusEnum {
  // 0:下注阶段;1:开奖中阶段;2:开奖结果展示阶段
  bet = 0,
  preparing = 1,
  showRes = 2,
}

export enum seat_type_enum {
  // : 座位类型;1:富豪位;2:神算子位;3:普通位置;4:观众席
  richMan = 1,
  luckyStar,
  nomal,
  guest,
}

export enum seat_status_enum {
  // 0:空位;1:有人
  vacant = 0,
  avaliable,
}
export enum relation_type_enum {
  同房间 = 1,
  好友 = 2,
}

export interface seat_list_item {
  seat_id?: number
  player_icon: string
  player_mid: number
  player_name: string
  seat_type?: seat_type_enum
  // 赢钱数目
  win_num?: number
  // 当前座位上是否有人
  status: seat_status_enum
  relation_type?: relation_type_enum
  // 针对guset的情况
  user_num?: number
}
export interface bet_detail_item {
  chip_value: number
  chip_num: number
}

export interface pokers_list_item {
  // 牌桌上不同档位
  pos_id: PosIdEnum
  bet_coins: number
  bet_details: bet_detail_item[]
  my_bets: number
  // n 是牌面显示的字符 2-10 JQKA s 是扑克牌的花色
  hand_pokers?: {n: string; s: SuitTypeEnum}[]
  is_win?: boolean
  poker_type?: string
}

export interface history_result_item {
  round_no: string
  win_pos: PosIdEnum
}

// 相关DOM操作
export interface imgProps {
  src: string
  top: number
  left: number
  width: number
  height: number
  className?: string
}
export interface apngProps extends imgProps {
  duration: number
}
// 下注状态
export enum bet_status_enum {
  failed = 0,
  suc = 1,
  outOfCoin = 2,
}
// 获取轮次结果
export interface win_list_item {
  seat_id: number
  win_num: number
  is_champion: boolean
}
export interface banner_item {
  id?: number // banner id
  cover?: string // 封面url
  link?: string
}

// JackPot 不同page展示
export enum JackPot_page_enum {
  num = 1,
  record,
  rule,
}

export interface jackpot_log_list_type {
  // jackpot中奖记录
  id: number
  mid: number
  avatar: string
  nick_name: string
  room_id: number
  room_host_avatar: string
  bet_coins: number
  reward_coins: number
  ct: string
}

export interface winner_type {
  ct: number
  bet_coins: number
  bet_user_name: string
  bet_user_avatar: string
  jackpot_reward: number
}
